export const gamification = {
  en: {
    category_completion: 'Completion',
    category_accuracy: 'Accuracy',
    category_speed: 'Speed',
    category_competition: 'Competition',
    category_exploration: 'Exploration',
    category_all: 'All',
    category_knowledge: 'Knowledge',
    category_consistency: 'Consistency',
    category_community: 'Community',
    category_mastery: 'Mastery',
    category_special: 'Special',
    category_quiz: 'Quiz',
    category_streak: 'Streak',
    category_challenge: 'Challenge',
    category_social: 'Social',
    category_milestone: 'Milestone',
    category_daily: 'Daily',
    category_weekly: 'Weekly',
    category_monthly: 'Monthly',
    // Rewards and XP
    rewards_earned: 'Rewards Earned',
    to_next_level: 'to Next Level',
    day_streak: 'Streak',
    view_progress: 'View Progress',
    experience_points: 'Experience Points',
    xp_short: 'XP',
    progress_to_next_level: 'Progress to Next Level',
    achievement_unlocked: 'Achievement Unlocked!',
    
    // Leveling
    current_level: 'Current Level',
    total_xp: 'Total XP',
    level: 'Level',
    rank: 'Rank',
    
    // Achievements
    achievements: 'Achievements',
    earned: 'Earned',
    total: 'Total',
    achievements_error: 'We could not load your achievements right now.',
    achievements_connection_error: 'Achievement updates are temporarily unavailable.',
    search_achievements: 'Search achievements',
    sort_by_name: 'Name',
    sort_by_progress: 'Progress',
    sort_by_xp: 'XP reward',
    sort_by_completed: 'Completed',
    no_achievements: 'No achievements yet',
    no_achievements_description: 'Keep answering faithfully and your milestones will appear here.',
    no_search_results: 'No matching achievements',
    try_different_search: 'Try a different word or clear the search.',
    more_to_go: 'more to go',
    completed_on: 'Completed on',
    ready_to_earn: 'Ready to earn',
    
    // Progress
    your_progress: 'Your Progress',
    calculating_rewards: 'Calculating Rewards',
    gamification_error: 'Unable to Load Rewards',
    
    // Streaks
    current_streak: 'Current Streak',
    longest_streak: 'Longest Streak',
    daily_verse: "Today's Verse",
    verse_prompt: "Let's explore this together",
    mark_as_read: 'Mark as Read',
    completed_today: 'Completed Today',
    daily_verse_completed_message: 'Daily verse completed! You earned 5 XP.',
    
    // Actions
    quick_actions: 'Quick Actions',
    best: 'Best',
    new_personal_best: 'New Personal Best',
    
    // Dashboard
    dashboard_subtitle: 'Track your growth, celebrate milestones, and grow in Scripture',
    achievements_hero_title: 'Milestones in Scripture',
    achievements_hero_subtitle: 'Celebrate faithful progress and see which milestones are next.',
    streak_calendar: 'Streak',
    day_singular: 'day',
    days: 'days',
    leaderboard: 'Leaderboard',
    quizzes_completed: 'quizzes',
    leaderboard_hero_title: 'Grow together',
    leaderboard_hero_subtitle: 'See how steady study and faithful rhythm are shaping your journey.',
    global_rank: 'your journey',
    quiz_stats: 'Quiz Stats',
    view_performance: 'View performance',
    you: 'You',
    next_level: 'Next level',
    needed: 'needed',
    top_10: 'Top 10',
    all_players: 'All players',
    local: 'Nearby',
    top_performers: 'Top performers',
    champion: 'Champion',
    full_rankings: 'Full rankings',
    loading_leaderboard: 'Loading leaderboard',
    loading_leaderboard_desc: 'Gathering the latest progress from players.',
    leaderboard_error: 'We could not load the leaderboard right now.',
    leaderboard_error_desc: 'Please try again in a moment.',
    no_rankings: 'No rankings yet',
    no_rankings_description: 'Keep playing and this leaderboard will start to fill up.',
    end_of_leaderboard: 'You have reached the end of the leaderboard.',
    pull_to_refresh: 'Pull to refresh',
    refresh_cta: 'Refresh rankings',
    refreshing: 'Refreshing...',
    longest: 'Longest',
    last_activity: 'Last activity',
    activity_types: 'Activity types',
    streak_milestones: 'Streak milestones',
    milestone_week: 'One week in the Word',
    milestone_month: 'One month of faithfulness',
    milestone_quarter: 'Three months of consistency',
    milestone_year: 'A full year in Scripture',
    streak_tips: 'Keep your streak alive',
    tip_start_streak: 'Start with one small faithful step today.',
    tip_daily_consistency: 'A few minutes with Scripture each day builds momentum.',
    tip_grace_period: 'If life gets busy, return gently tomorrow and keep going.',
    tip_multiple_activities: 'Quizzes, verses, and shared play can all strengthen your rhythm.',
    tip_set_reminders: 'Set a daily reminder so Scripture stays part of your day.',
    tip_keep_going: 'You are building a beautiful habit. Keep showing up.',
    start_your_streak: 'Start your streak',
    streak_calendar_error: 'We could not load your streak right now.',
    streak_connection_error: 'Live streak updates are temporarily unavailable.',
    
    // Status and Messages
    not_available: 'N/A',
    unranked: 'Unranked',
    congratulations: 'Congratulations!',
    loading_progress: 'Loading progress',
    error_loading_progress: 'Error loading progress',
    try_again: 'Try again',
    completed: 'Completed',
    unlocked: 'unlocked',
    recent_activity: 'Recent Activity',
    recent_xp_earned: 'Recent XP Earned',
    recent_achievements_earned: 'Recent Achievements Earned',
    
    // Ranks
    beginner: 'Beginner',
    intermediate: 'Intermediate',
    advanced: 'Advanced',
    expert: 'Expert',
    master: 'Master',
    
    // Quiz completion messages
    quiz_completed_with_score: 'Quiz completed with {score}% score',
    quiz_completed: 'Quiz completed',
    daily_challenge_completed: 'Daily challenge completed',
  },
  
  fr: {
    category_completion: 'Réussite',
    category_accuracy: 'Précision',
    category_speed: 'Vitesse',
    category_competition: 'Compétition',
    category_exploration: 'Exploration',
    longest: 'Plus longue',
    last_activity: 'Dernière activité',
    streak_milestones: 'Étapes de la série',
    milestone_week: 'Une semaine dans la Parole',
    milestone_month: 'Un mois de fidélité',
    milestone_quarter: 'Trois mois de constance',
    milestone_year: 'Une année entière dans les Écritures',
    streak_tips: 'Gardez votre série active',
    tip_start_streak: 'Commencez aujourd\'hui par un petit pas fidèle.',
    tip_daily_consistency: 'Quelques minutes avec les Écritures chaque jour créent un élan.',
    tip_grace_period: 'Si la vie est chargée, revenez doucement demain et continuez.',
    tip_multiple_activities: 'Quiz, versets et jeu partagé renforcent tous votre rythme.',
    tip_set_reminders: 'Programmez un rappel quotidien pour que les Écritures fassent partie de votre journée.',
    tip_keep_going: 'Vous construisez une belle habitude. Continuez à être présent.',
    start_your_streak: 'Commencez votre série',
    streak_calendar_error: 'Impossible de charger votre série pour le moment.',
    streak_connection_error: 'Les mises à jour de la série sont temporairement indisponibles.',
    category_all: 'Tous',
    category_knowledge: 'Connaissance',
    category_consistency: 'Régularité',
    category_community: 'Communauté',
    category_mastery: 'Maîtrise',
    category_special: 'Spécial',
    category_quiz: 'Quiz',
    category_streak: 'Série',
    category_challenge: 'Défi',
    category_social: 'Social',
    category_milestone: 'Étape',
    category_daily: 'Quotidien',
    category_weekly: 'Hebdomadaire',
    category_monthly: 'Mensuel',
    achievements_connection_error: 'Les mises à jour des succès sont temporairement indisponibles.',
    achievements_error: 'Impossible de charger vos succès pour le moment.',
    no_achievements: 'Aucun succès pour le moment',
    no_achievements_description: 'Continuez à répondre avec fidélité et vos étapes apparaîtront ici.',
    no_search_results: 'Aucun succès correspondant',
    search_achievements: 'Rechercher des succès',
    sort_by_completed: 'Terminés',
    sort_by_name: 'Nom',
    sort_by_progress: 'Progression',
    sort_by_xp: 'Récompense XP',
    try_different_search: 'Essayez un autre mot ou effacez la recherche.',
    all_players: 'Tous les joueurs',
    champion: 'Champion',
    end_of_leaderboard: 'Vous avez atteint la fin du classement.',
    full_rankings: 'Classement complet',
    leaderboard_error: 'Impossible de charger le classement pour le moment.',
    leaderboard_error_desc: 'Veuillez réessayer dans un instant.',
    loading_leaderboard: 'Chargement du classement',
    loading_leaderboard_desc: 'Récupération des dernières progressions des joueurs.',
    local: 'Proches',
    needed: 'requis',
    next_level: 'Niveau suivant',
    no_rankings: 'Pas encore de classement',
    no_rankings_description: 'Continuez à jouer et ce classement commencera à se remplir.',
    pull_to_refresh: 'Tirez pour actualiser',
    refreshing: 'Actualisation…',
    top_10: 'Top 10',
    top_performers: 'Meilleurs joueurs',
    you: 'Vous',
    // Rewards and XP
    rewards_earned: 'Récompenses Gagnées',
    to_next_level: 'au Niveau Suivant',
    day_streak: 'Série',
    view_progress: 'Voir les Progrès',
    experience_points: 'Points d\'Expérience',
    xp_short: 'EXP',
    progress_to_next_level: 'Progrès vers le Niveau Suivant',
    achievement_unlocked: 'Succès Débloqué !',
    
    // Leveling
    current_level: 'Niveau Actuel',
    total_xp: 'XP Total',
    level: 'Niveau',
    rank: 'Rang',
    
    // Achievements
    achievements: 'Succès',
    earned: 'Gagné',
    total: 'Total',
    more_to_go: 'restants',
    completed_on: 'Terminé le',
    ready_to_earn: 'Prêt à gagner',
    
    // Progress
    your_progress: 'Vos Progrès',
    calculating_rewards: 'Calcul des Récompenses',
    gamification_error: 'Impossible de Charger les Récompenses',
    
    // Streaks
    current_streak: 'Série Actuelle',
    longest_streak: 'Plus Longue Série',
    daily_verse: "Verset d'Aujourd'hui",
    verse_prompt: 'Explorons cela ensemble',
    mark_as_read: 'Marquer comme Lu',
    completed_today: 'Terminé Aujourd\'hui',
    daily_verse_completed_message: 'Verset du jour terminé ! Vous avez gagné 5 EXP.',
    
    // Actions
    quick_actions: 'Actions Rapides',
    best: 'Meilleur',
    new_personal_best: 'Nouveau Record Personnel',
    
    // Dashboard
    dashboard_subtitle: 'Suivez votre croissance, célébrez vos étapes et grandissez dans les Écritures',
    achievements_hero_title: 'Étapes dans les Écritures',
    achievements_hero_subtitle: 'Célébrez votre progression fidèle et voyez les prochaines étapes.',
    streak_calendar: 'Série',
    day_singular: 'jour',
    days: 'jours',
    leaderboard: 'Classement',
    quizzes_completed: 'quiz',
    leaderboard_hero_title: 'Grandir ensemble',
    leaderboard_hero_subtitle: 'Voyez comment une étude fidèle façonne votre parcours.',
    global_rank: 'votre parcours',
    quiz_stats: 'Statistiques de Quiz',
    view_performance: 'Voir les performances',
    
    // Status and Messages
    not_available: 'N/D',
    unranked: 'Non classé',
    congratulations: 'Félicitations!',
    loading_progress: 'Chargement des progrès',
    error_loading_progress: 'Erreur de chargement des progrès',
    try_again: 'Réessayer',
    refresh_cta: 'Actualiser le classement',
    completed: 'Terminé',
    activity_types: 'Types d’activité',
    unlocked: 'débloqués',
    recent_activity: 'Activité Récente',
    recent_xp_earned: 'EXP Récente Gagnée',
    recent_achievements_earned: 'Succès Récents Gagnés',
    
    // Ranks
    beginner: 'Débutant',
    scholar: 'Érudit',
    teacher: 'Enseignant',
    sage: 'Sage',
    intermediate: 'Intermédiaire',
    advanced: 'Avancé',
    expert: 'Expert',
    master: 'Maître',
    
    // Quiz completion messages
    quiz_completed_with_score: 'Quiz terminé avec {score}% de score',
    quiz_completed: 'Quiz terminé',
    daily_challenge_completed: 'Défi quotidien terminé',
  },
  
  es: {
    category_completion: 'Finalización',
    category_accuracy: 'Precisión',
    category_speed: 'Velocidad',
    category_competition: 'Competencia',
    category_exploration: 'Exploración',
    longest: 'Más larga',
    last_activity: 'Última actividad',
    streak_milestones: 'Hitos de la racha',
    milestone_week: 'Una semana en la Palabra',
    milestone_month: 'Un mes de fidelidad',
    milestone_quarter: 'Tres meses de constancia',
    milestone_year: 'Un año completo en las Escrituras',
    streak_tips: 'Mantén viva tu racha',
    tip_start_streak: 'Empieza hoy con un pequeño paso fiel.',
    tip_daily_consistency: 'Unos minutos con las Escrituras cada día generan impulso.',
    tip_grace_period: 'Si la vida se complica, vuelve con calma mañana y sigue.',
    tip_multiple_activities: 'Los quizzes, los versículos y el juego compartido fortalecen tu ritmo.',
    tip_set_reminders: 'Configura un recordatorio diario para que las Escrituras sean parte de tu día.',
    tip_keep_going: 'Estás construyendo un hermoso hábito. Sigue presente.',
    start_your_streak: 'Comienza tu racha',
    streak_calendar_error: 'No pudimos cargar tu racha en este momento.',
    streak_connection_error: 'Las actualizaciones de la racha no están disponibles por el momento.',
    category_all: 'Todos',
    category_knowledge: 'Conocimiento',
    category_consistency: 'Constancia',
    category_community: 'Comunidad',
    category_mastery: 'Maestría',
    category_special: 'Especial',
    category_quiz: 'Quiz',
    category_streak: 'Racha',
    category_challenge: 'Reto',
    category_social: 'Social',
    category_milestone: 'Hito',
    category_daily: 'Diario',
    category_weekly: 'Semanal',
    category_monthly: 'Mensual',
    achievements_connection_error: 'Las actualizaciones de logros no están disponibles por el momento.',
    achievements_error: 'No pudimos cargar tus logros en este momento.',
    no_achievements: 'Aún no hay logros',
    no_achievements_description: 'Sigue respondiendo con fidelidad y tus hitos aparecerán aquí.',
    no_search_results: 'No hay logros que coincidan',
    search_achievements: 'Buscar logros',
    sort_by_completed: 'Completados',
    sort_by_name: 'Nombre',
    sort_by_progress: 'Progreso',
    sort_by_xp: 'Recompensa de XP',
    try_different_search: 'Prueba con otra palabra o borra la búsqueda.',
    // Rewards and XP
    rewards_earned: 'Recompensas Obtenidas',
    to_next_level: 'al Siguiente Nivel',
    day_streak: 'Racha',
    view_progress: 'Ver Progreso',
    experience_points: 'Puntos de Experiencia',
    xp_short: 'EXP',
    progress_to_next_level: 'Progreso al Siguiente Nivel',
    achievement_unlocked: '¡Logro Desbloqueado!',
    
    // Leveling
    current_level: 'Nivel Actual',
    total_xp: 'XP Total',
    level: 'Nivel',
    rank: 'Rango',
    
    // Achievements
    achievements: 'Logros',
    earned: 'Obtenido',
    total: 'Total',
    more_to_go: 'más para completar',
    completed_on: 'Completado el',
    ready_to_earn: 'Listo para ganar',
    
    // Progress
    your_progress: 'Tu Progreso',
    calculating_rewards: 'Calculando Recompensas',
    gamification_error: 'No se Pudieron Cargar las Recompensas',
    
    // Streaks
    current_streak: 'Racha Actual',
    longest_streak: 'Racha Más Larga',
    daily_verse: 'Versículo de Hoy',
    verse_prompt: 'Exploremos esto juntos',
    mark_as_read: 'Marcar como Leído',
    completed_today: 'Completado Hoy',
    daily_verse_completed_message: '¡Versículo diario completado! Has ganado 5 EXP.',
    
    // Actions
    quick_actions: 'Acciones Rápidas',
    best: 'Mejor',
    new_personal_best: 'Nuevo Récord Personal',
    
    // Dashboard
    dashboard_subtitle: 'Sigue tu crecimiento, celebra tus logros y crece en las Escrituras',
    achievements_hero_title: 'Hitos en las Escrituras',
    achievements_hero_subtitle: 'Celebra tu progreso fiel y mira cuáles son tus próximos hitos.',
    streak_calendar: 'Racha',
    day_singular: 'día',
    days: 'días',
    leaderboard: 'Clasificación',
    quizzes_completed: 'quizzes',
    leaderboard_hero_title: 'Crecer juntos',
    leaderboard_hero_subtitle: 'Mira cómo el estudio constante está formando tu camino.',
    global_rank: 'tu camino',
    quiz_stats: 'Estadísticas de Quiz',
    view_performance: 'Ver rendimiento',
    you: 'Tú',
    next_level: 'Siguiente nivel',
    needed: 'necesarios',
    top_10: 'Top 10',
    all_players: 'Todos',
    local: 'Cercanos',
    top_performers: 'Mejores jugadores',
    champion: 'Campeón',
    full_rankings: 'Clasificación completa',
    loading_leaderboard: 'Cargando clasificación',
    loading_leaderboard_desc: 'Reuniendo el progreso más reciente.',
    leaderboard_error: 'No pudimos cargar la clasificación ahora.',
    leaderboard_error_desc: 'Inténtalo de nuevo en un momento.',
    no_rankings: 'Aún no hay clasificación',
    no_rankings_description: 'Sigue jugando y esta tabla empezará a llenarse.',
    end_of_leaderboard: 'Has llegado al final de la clasificación.',
    pull_to_refresh: 'Tira para actualizar',
    refreshing: 'Actualizando...',
    
    // Status and Messages
    not_available: 'N/D',
    unranked: 'Sin ranking',
    congratulations: '¡Felicitaciones!',
    loading_progress: 'Cargando progreso',
    error_loading_progress: 'Error cargando progreso',
    try_again: 'Intentar de nuevo',
    refresh_cta: 'Actualizar clasificación',
    completed: 'Completado',
    activity_types: 'Tipos de actividad',
    unlocked: 'desbloqueados',
    recent_activity: 'Actividad Reciente',
    recent_xp_earned: 'EXP Reciente Ganada',
    recent_achievements_earned: 'Logros Recientes Ganados',
    
    // Ranks
    beginner: 'Principiante',
    scholar: 'Estudiante',
    teacher: 'Maestro',
    sage: 'Sabio',
    intermediate: 'Intermedio',
    advanced: 'Avanzado',
    expert: 'Experto',
    master: 'Maestro',
    
    // Quiz completion messages
    quiz_completed_with_score: 'Quiz completado con {score}% de puntuación',
    quiz_completed: 'Quiz completado',
    daily_challenge_completed: 'Desafío diario completado',
  },
  
  de: {
    category_completion: 'Abschluss',
    category_accuracy: 'Genauigkeit',
    category_speed: 'Tempo',
    category_competition: 'Wettbewerb',
    category_exploration: 'Entdeckung',
    longest: 'Längste',
    last_activity: 'Letzte Aktivität',
    streak_milestones: 'Serien-Meilensteine',
    milestone_week: 'Eine Woche im Wort',
    milestone_month: 'Ein Monat Treue',
    milestone_quarter: 'Drei Monate Beständigkeit',
    milestone_year: 'Ein ganzes Jahr in der Schrift',
    streak_tips: 'Halte deine Serie am Leben',
    tip_start_streak: 'Beginne heute mit einem kleinen treuen Schritt.',
    tip_daily_consistency: 'Ein paar Minuten mit der Schrift täglich bringen Schwung.',
    tip_grace_period: 'Wenn das Leben hektisch wird, komm morgen sanft zurück und mach weiter.',
    tip_multiple_activities: 'Quizze, Verse und gemeinsames Spielen stärken deinen Rhythmus.',
    tip_set_reminders: 'Stelle eine tägliche Erinnerung ein, damit die Schrift Teil deines Tages bleibt.',
    tip_keep_going: 'Du baust eine schöne Gewohnheit auf. Bleib dran.',
    start_your_streak: 'Starte deine Serie',
    streak_calendar_error: 'Deine Serie konnte gerade nicht geladen werden.',
    streak_connection_error: 'Live-Serien-Updates sind vorübergehend nicht verfügbar.',
    category_all: 'Alle',
    category_knowledge: 'Wissen',
    category_consistency: 'Beständigkeit',
    category_community: 'Gemeinschaft',
    category_mastery: 'Meisterschaft',
    category_special: 'Besonders',
    category_quiz: 'Quiz',
    category_streak: 'Serie',
    category_challenge: 'Herausforderung',
    category_social: 'Sozial',
    category_milestone: 'Meilenstein',
    category_daily: 'Täglich',
    category_weekly: 'Wöchentlich',
    category_monthly: 'Monatlich',
    achievements_connection_error: 'Erfolgs-Updates sind vorübergehend nicht verfügbar.',
    achievements_error: 'Deine Erfolge konnten gerade nicht geladen werden.',
    no_achievements: 'Noch keine Erfolge',
    no_achievements_description: 'Antworte weiter treu, und deine Meilensteine erscheinen hier.',
    no_search_results: 'Keine passenden Erfolge',
    search_achievements: 'Erfolge suchen',
    sort_by_completed: 'Abgeschlossen',
    sort_by_name: 'Name',
    sort_by_progress: 'Fortschritt',
    sort_by_xp: 'XP-Belohnung',
    try_different_search: 'Versuche ein anderes Wort oder lösche die Suche.',
    all_players: 'Alle Spieler',
    champion: 'Champion',
    end_of_leaderboard: 'Du hast das Ende der Rangliste erreicht.',
    full_rankings: 'Gesamtwertung',
    leaderboard_error: 'Die Rangliste konnte gerade nicht geladen werden.',
    leaderboard_error_desc: 'Bitte versuche es gleich noch einmal.',
    loading_leaderboard: 'Rangliste wird geladen',
    loading_leaderboard_desc: 'Die neuesten Fortschritte der Spieler werden gesammelt.',
    local: 'Nähe',
    needed: 'nötig',
    next_level: 'Nächstes Level',
    no_rankings: 'Noch keine Platzierungen',
    no_rankings_description: 'Spiele weiter, dann füllt sich diese Rangliste nach und nach.',
    pull_to_refresh: 'Zum Aktualisieren ziehen',
    refreshing: 'Wird aktualisiert…',
    top_10: 'Top 10',
    top_performers: 'Beste Spieler',
    you: 'Du',
    // Rewards and XP
    rewards_earned: 'Belohnungen Erhalten',
    to_next_level: 'bis zum Nächsten Level',
    day_streak: 'Serie',
    view_progress: 'Fortschritt Anzeigen',
    experience_points: 'Erfahrungspunkte',
    xp_short: 'EP',
    progress_to_next_level: 'Fortschritt zum Nächsten Level',
    achievement_unlocked: 'Erfolg Freigeschaltet!',
    
    // Leveling
    current_level: 'Aktuelles Level',
    total_xp: 'Gesamt XP',
    level: 'Level',
    rank: 'Rang',
    
    // Achievements
    achievements: 'Erfolge',
    earned: 'Verdient',
    total: 'Gesamt',
    more_to_go: 'noch offen',
    completed_on: 'Abgeschlossen am',
    ready_to_earn: 'Bereit zum Verdienen',
    
    // Progress
    your_progress: 'Ihr Fortschritt',
    calculating_rewards: 'Belohnungen Berechnen',
    gamification_error: 'Belohnungen Konnten Nicht Geladen Werden',
    
    // Streaks
    current_streak: 'Aktuelle Strähne',
    longest_streak: 'Längste Strähne',
    daily_verse: 'Vers des Tages',
    verse_prompt: 'Lass uns das gemeinsam erkunden',
    mark_as_read: 'Als Gelesen Markieren',
    completed_today: 'Heute Abgeschlossen',
    daily_verse_completed_message: 'Tagesvers abgeschlossen! Du hast 5 EP verdient.',
    
    // Actions
    quick_actions: 'Schnellaktionen',
    best: 'Beste',
    new_personal_best: 'Neue Bestleistung',
    
    // Dashboard
    dashboard_subtitle: 'Verfolge dein Wachstum, feiere Meilensteine und wachse in der Schrift',
    achievements_hero_title: 'Meilensteine in der Schrift',
    achievements_hero_subtitle: 'Feiere treuen Fortschritt und sieh, welche Meilensteine als Nächstes kommen.',
    streak_calendar: 'Serie',
    day_singular: 'Tag',
    days: 'Tage',
    leaderboard: 'Bestenliste',
    quizzes_completed: 'Quizze',
    leaderboard_hero_title: 'Gemeinsam wachsen',
    leaderboard_hero_subtitle: 'Sieh, wie beständiges Lernen deinen Weg formt.',
    global_rank: 'deine Reise',
    quiz_stats: 'Quiz-Statistiken',
    view_performance: 'Leistung anzeigen',
    
    // Status and Messages
    not_available: 'N/V',
    unranked: 'Nicht platziert',
    congratulations: 'Glückwünsche!',
    loading_progress: 'Fortschritt laden',
    error_loading_progress: 'Fehler beim Laden des Fortschritts',
    try_again: 'Erneut versuchen',
    refresh_cta: 'Rangliste aktualisieren',
    completed: 'Abgeschlossen',
    activity_types: 'Aktivitätstypen',
    unlocked: 'freigeschaltet',
    recent_activity: 'Letzte Aktivität',
    recent_xp_earned: 'Kürzlich verdiente EP',
    recent_achievements_earned: 'Kürzlich erreichte Erfolge',
    
    // Ranks
    beginner: 'Anfänger',
    scholar: 'Gelehrter',
    teacher: 'Lehrer',
    sage: 'Weiser',
    intermediate: 'Fortgeschritten',
    advanced: 'Erweitert',
    expert: 'Experte',
    master: 'Meister',
    
    // Quiz completion messages
    quiz_completed_with_score: 'Quiz mit {score}% Punktzahl abgeschlossen',
    quiz_completed: 'Quiz abgeschlossen',
    daily_challenge_completed: 'Tägliche Herausforderung abgeschlossen',
  },
  
  pt: {
    category_completion: 'Conclusão',
    category_accuracy: 'Precisão',
    category_speed: 'Velocidade',
    category_competition: 'Competição',
    category_exploration: 'Exploração',
    longest: 'Maior',
    last_activity: 'Última atividade',
    streak_milestones: 'Marcos da sequência',
    milestone_week: 'Uma semana na Palavra',
    milestone_month: 'Um mês de fidelidade',
    milestone_quarter: 'Três meses de constância',
    milestone_year: 'Um ano inteiro nas Escrituras',
    streak_tips: 'Mantenha sua sequência viva',
    tip_start_streak: 'Comece hoje com um pequeno passo fiel.',
    tip_daily_consistency: 'Alguns minutos com as Escrituras todos os dias criam impulso.',
    tip_grace_period: 'Se a vida ficar corrida, volte com calma amanhã e continue.',
    tip_multiple_activities: 'Quizzes, versículos e jogo compartilhado fortalecem seu ritmo.',
    tip_set_reminders: 'Defina um lembrete diário para que as Escrituras façam parte do seu dia.',
    tip_keep_going: 'Você está construindo um belo hábito. Continue presente.',
    start_your_streak: 'Comece sua sequência',
    streak_calendar_error: 'Não foi possível carregar sua sequência agora.',
    streak_connection_error: 'As atualizações da sequência estão temporariamente indisponíveis.',
    category_all: 'Todos',
    category_knowledge: 'Conhecimento',
    category_consistency: 'Consistência',
    category_community: 'Comunidade',
    category_mastery: 'Maestria',
    category_special: 'Especial',
    category_quiz: 'Quiz',
    category_streak: 'Sequência',
    category_challenge: 'Desafio',
    category_social: 'Social',
    category_milestone: 'Marco',
    category_daily: 'Diário',
    category_weekly: 'Semanal',
    category_monthly: 'Mensal',
    achievements_connection_error: 'As atualizações de conquistas estão temporariamente indisponíveis.',
    achievements_error: 'Não foi possível carregar suas conquistas agora.',
    no_achievements: 'Ainda não há conquistas',
    no_achievements_description: 'Continue respondendo com fidelidade e seus marcos aparecerão aqui.',
    no_search_results: 'Nenhuma conquista correspondente',
    search_achievements: 'Buscar conquistas',
    sort_by_completed: 'Concluídas',
    sort_by_name: 'Nome',
    sort_by_progress: 'Progresso',
    sort_by_xp: 'Recompensa de XP',
    try_different_search: 'Tente outra palavra ou limpe a busca.',
    all_players: 'Todos os jogadores',
    champion: 'Campeão',
    end_of_leaderboard: 'Você chegou ao fim do ranking.',
    full_rankings: 'Classificação completa',
    leaderboard_error: 'Não foi possível carregar o ranking agora.',
    leaderboard_error_desc: 'Tente novamente em instantes.',
    loading_leaderboard: 'Carregando o ranking',
    loading_leaderboard_desc: 'Reunindo o progresso mais recente dos jogadores.',
    local: 'Perto',
    needed: 'necessários',
    next_level: 'Próximo nível',
    no_rankings: 'Ainda não há classificações',
    no_rankings_description: 'Continue jogando e este ranking começará a ser preenchido.',
    pull_to_refresh: 'Puxe para atualizar',
    refreshing: 'Atualizando…',
    top_10: 'Top 10',
    top_performers: 'Melhores jogadores',
    you: 'Você',
    // Rewards and XP
    rewards_earned: 'Recompensas Obtidas',
    to_next_level: 'para o Próximo Nível',
    day_streak: 'Sequência',
    view_progress: 'Ver Progresso',
    experience_points: 'Pontos de Experiência',
    xp_short: 'EXP',
    progress_to_next_level: 'Progresso para o Próximo Nível',
    achievement_unlocked: 'Conquista Desbloqueada!',
    
    // Leveling
    current_level: 'Nível Atual',
    total_xp: 'XP Total',
    level: 'Nível',
    rank: 'Posição',
    
    // Achievements
    achievements: 'Conquistas',
    earned: 'Obtido',
    total: 'Total',
    more_to_go: 'restantes',
    completed_on: 'Concluído em',
    ready_to_earn: 'Pronto para ganhar',
    
    // Progress
    your_progress: 'Seu Progresso',
    calculating_rewards: 'Calculando Recompensas',
    gamification_error: 'Não Foi Possível Carregar as Recompensas',
    
    // Streaks
    current_streak: 'Sequência Atual',
    longest_streak: 'Sequência Mais Longa',
    daily_verse: 'Versículo de Hoje',
    verse_prompt: 'Vamos explorar isso juntos',
    mark_as_read: 'Marcar como Lido',
    completed_today: 'Concluído Hoje',
    daily_verse_completed_message: 'Versículo diário concluído! Você ganhou 5 EXP.',
    
    // Actions
    quick_actions: 'Ações Rápidas',
    best: 'Melhor',
    new_personal_best: 'Novo Recorde Pessoal',
    
    // Dashboard
    dashboard_subtitle: 'Acompanhe seu crescimento, celebre conquistas e cresça nas Escrituras',
    achievements_hero_title: 'Marcos nas Escrituras',
    achievements_hero_subtitle: 'Celebre seu progresso fiel e veja quais marcos vêm a seguir.',
    streak_calendar: 'Sequência',
    day_singular: 'dia',
    days: 'dias',
    leaderboard: 'Classificação',
    quizzes_completed: 'quizzes',
    leaderboard_hero_title: 'Crescer juntos',
    leaderboard_hero_subtitle: 'Veja como o estudo constante está moldando sua jornada.',
    global_rank: 'sua jornada',
    quiz_stats: 'Estatísticas do Quiz',
    view_performance: 'Ver desempenho',
    
    // Status and Messages
    not_available: 'N/D',
    unranked: 'Sem classificação',
    congratulations: 'Parabéns!',
    loading_progress: 'Carregando progresso',
    error_loading_progress: 'Erro ao carregar progresso',
    try_again: 'Tentar novamente',
    refresh_cta: 'Atualizar ranking',
    completed: 'Concluído',
    activity_types: 'Tipos de atividade',
    unlocked: 'desbloqueadas',
    recent_activity: 'Atividade Recente',
    recent_xp_earned: 'EXP Recente Ganha',
    recent_achievements_earned: 'Conquistas Recentes Ganhas',
    
    // Ranks
    beginner: 'Iniciante',
    scholar: 'Estudioso',
    teacher: 'Professor',
    sage: 'Sábio',
    intermediate: 'Intermediário',
    advanced: 'Avançado',
    expert: 'Especialista',
    master: 'Mestre',
    
    // Quiz completion messages
    quiz_completed_with_score: 'Quiz concluído com {score}% de pontuação',
    quiz_completed: 'Quiz concluído',
    daily_challenge_completed: 'Desafio diário concluído',
  },
  
  ru: {
    category_completion: 'Прохождение',
    category_accuracy: 'Точность',
    category_speed: 'Скорость',
    category_competition: 'Соревнование',
    category_exploration: 'Исследование',
    longest: 'Рекорд',
    last_activity: 'Последняя активность',
    streak_milestones: 'Вехи серии',
    milestone_week: 'Неделя со Словом',
    milestone_month: 'Месяц верности',
    milestone_quarter: 'Три месяца постоянства',
    milestone_year: 'Целый год в Писании',
    streak_tips: 'Не прерывайте серию',
    tip_start_streak: 'Начните сегодня с одного маленького шага.',
    tip_daily_consistency: 'Несколько минут с Писанием каждый день задают ритм.',
    tip_grace_period: 'Если день выдался суетным, спокойно вернитесь завтра и продолжайте.',
    tip_multiple_activities: 'Викторины, стихи и совместная игра укрепляют ваш ритм.',
    tip_set_reminders: 'Включите ежедневное напоминание, чтобы Писание оставалось частью вашего дня.',
    tip_keep_going: 'Вы формируете прекрасную привычку. Продолжайте приходить.',
    start_your_streak: 'Начните свою серию',
    streak_calendar_error: 'Сейчас не удалось загрузить вашу серию.',
    streak_connection_error: 'Обновления серии временно недоступны.',
    category_all: 'Все',
    category_knowledge: 'Знание',
    category_consistency: 'Постоянство',
    category_community: 'Сообщество',
    category_mastery: 'Мастерство',
    category_special: 'Особые',
    category_quiz: 'Викторина',
    category_streak: 'Серия',
    category_challenge: 'Испытание',
    category_social: 'Общение',
    category_milestone: 'Веха',
    category_daily: 'Ежедневно',
    category_weekly: 'Еженедельно',
    category_monthly: 'Ежемесячно',
    achievements_connection_error: 'Обновления достижений временно недоступны.',
    achievements_error: 'Сейчас не удалось загрузить ваши достижения.',
    no_achievements: 'Достижений пока нет',
    no_achievements_description: 'Продолжайте отвечать, и ваши вехи появятся здесь.',
    no_search_results: 'Подходящих достижений нет',
    search_achievements: 'Поиск достижений',
    sort_by_completed: 'Завершённые',
    sort_by_name: 'Название',
    sort_by_progress: 'Прогресс',
    sort_by_xp: 'Награда XP',
    try_different_search: 'Попробуйте другое слово или очистите поиск.',
    all_players: 'Все игроки',
    champion: 'Чемпион',
    end_of_leaderboard: 'Вы дошли до конца таблицы лидеров.',
    full_rankings: 'Полный рейтинг',
    leaderboard_error: 'Сейчас не удалось загрузить таблицу лидеров.',
    leaderboard_error_desc: 'Повторите попытку через минуту.',
    loading_leaderboard: 'Загрузка таблицы лидеров',
    loading_leaderboard_desc: 'Собираем свежий прогресс игроков.',
    local: 'Рядом',
    needed: 'нужно',
    next_level: 'Следующий уровень',
    no_rankings: 'Рейтинга пока нет',
    no_rankings_description: 'Продолжайте играть, и таблица начнёт заполняться.',
    pull_to_refresh: 'Потяните, чтобы обновить',
    refreshing: 'Обновление…',
    top_10: 'Топ-10',
    top_performers: 'Лучшие игроки',
    you: 'Вы',
    // Rewards and XP
    rewards_earned: 'Полученные Награды',
    to_next_level: 'до Следующего Уровня',
    day_streak: 'Серия',
    view_progress: 'Посмотреть Прогресс',
    experience_points: 'Очки Опыта',
    xp_short: 'ОП',
    progress_to_next_level: 'Прогресс до Следующего Уровня',
    achievement_unlocked: 'Достижение Разблокировано!',
    
    // Leveling
    current_level: 'Текущий Уровень',
    total_xp: 'Общий ОП',
    level: 'Уровень',
    rank: 'Ранг',
    
    // Achievements
    achievements: 'Достижения',
    earned: 'Заработано',
    total: 'Всего',
    more_to_go: 'осталось',
    completed_on: 'Завершено',
    ready_to_earn: 'Готово к получению',
    
    // Progress
    your_progress: 'Ваш Прогресс',
    calculating_rewards: 'Расчет Наград',
    gamification_error: 'Не Удается Загрузить Награды',
    
    // Streaks
    current_streak: 'Текущая Серия',
    longest_streak: 'Самая Длинная Серия',
    daily_verse: 'Стих Дня',
    verse_prompt: 'Давайте вместе это изучим',
    mark_as_read: 'Отметить как Прочитанное',
    completed_today: 'Выполнено Сегодня',
    daily_verse_completed_message: 'Стих дня завершён! Вы получили 5 ОП.',
    
    // Actions
    quick_actions: 'Быстрые Действия',
    best: 'Лучший',
    new_personal_best: 'Новый Личный Рекорд',
    
    // Dashboard
    dashboard_subtitle: 'Следите за ростом, отмечайте достижения и возрастайте в Писании',
    achievements_hero_title: 'Вехи в Писании',
    achievements_hero_subtitle: 'Отмечайте верный прогресс и смотрите, какие вехи ждут впереди.',
    streak_calendar: 'Серия',
    day_singular: 'день',
    days: 'дней',
    leaderboard: 'Таблица лидеров',
    quizzes_completed: 'квизов',
    leaderboard_hero_title: 'Расти вместе',
    leaderboard_hero_subtitle: 'Посмотрите, как постоянное изучение формирует ваш путь.',
    global_rank: 'ваш путь',
    quiz_stats: 'Статистика Квизов',
    view_performance: 'Посмотреть производительность',
    
    // Status and Messages
    not_available: 'Н/Д',
    unranked: 'Без ранга',
    congratulations: 'Поздравляем!',
    loading_progress: 'Загрузка прогресса',
    error_loading_progress: 'Ошибка загрузки прогресса',
    try_again: 'Попробовать снова',
    refresh_cta: 'Обновить рейтинг',
    completed: 'Завершено',
    activity_types: 'Типы активности',
    unlocked: 'разблокированы',
    recent_activity: 'Недавняя Активность',
    recent_xp_earned: 'Недавно Заработанный ОП',
    recent_achievements_earned: 'Недавно Полученные Достижения',
    
    // Ranks
    beginner: 'Новичок',
    scholar: 'Знаток',
    teacher: 'Учитель',
    sage: 'Мудрец',
    intermediate: 'Средний',
    advanced: 'Продвинутый',
    expert: 'Эксперт',
    master: 'Мастер',
    
    // Quiz completion messages
    quiz_completed_with_score: 'Квиз завершён с результатом {score}%',
    quiz_completed: 'Квиз завершён',
    daily_challenge_completed: 'Ежедневное задание выполнено',
  },
  
  tl: {
    category_completion: 'Pagtatapos',
    category_accuracy: 'Katumpakan',
    category_speed: 'Bilis',
    category_competition: 'Kompetisyon',
    category_exploration: 'Paggalugad',
    longest: 'Pinakamahaba',
    last_activity: 'Huling aktibidad',
    streak_milestones: 'Mga milestone ng streak',
    milestone_week: 'Isang linggo sa Salita',
    milestone_month: 'Isang buwan ng katapatan',
    milestone_quarter: 'Tatlong buwan ng pagkakapare-pareho',
    milestone_year: 'Isang buong taon sa Kasulatan',
    streak_tips: 'Panatilihing buhay ang iyong streak',
    tip_start_streak: 'Magsimula ngayon sa isang maliit na tapat na hakbang.',
    tip_daily_consistency: 'Ang ilang minuto sa Kasulatan araw-araw ay nagbubuo ng momentum.',
    tip_grace_period: 'Kung abala ang buhay, bumalik nang dahan-dahan bukas at magpatuloy.',
    tip_multiple_activities: 'Ang mga quiz, talata, at sama-samang laro ay nagpapatatag ng iyong ritmo.',
    tip_set_reminders: 'Magtakda ng pang-araw-araw na paalala para manatiling bahagi ng araw mo ang Kasulatan.',
    tip_keep_going: 'Bumubuo ka ng magandang ugali. Patuloy na magpakita.',
    start_your_streak: 'Simulan ang iyong streak',
    streak_calendar_error: 'Hindi ma-load ang iyong streak ngayon.',
    streak_connection_error: 'Pansamantalang hindi available ang mga live na update ng streak.',
    category_all: 'Lahat',
    category_knowledge: 'Kaalaman',
    category_consistency: 'Tuloy-tuloy',
    category_community: 'Komunidad',
    category_mastery: 'Kahusayan',
    category_special: 'Espesyal',
    category_quiz: 'Quiz',
    category_streak: 'Sunod-sunod',
    category_challenge: 'Hamon',
    category_social: 'Sosyal',
    category_milestone: 'Mahalagang Hakbang',
    category_daily: 'Araw-araw',
    category_weekly: 'Lingguhan',
    category_monthly: 'Buwanan',
    achievements_connection_error: 'Pansamantalang hindi available ang mga update sa achievement.',
    achievements_error: 'Hindi ma-load ang iyong mga achievement ngayon.',
    no_achievements: 'Wala pang achievement',
    no_achievements_description: 'Magpatuloy sa tapat na pagsagot at lalabas dito ang iyong mga milestone.',
    no_search_results: 'Walang tugmang achievement',
    search_achievements: 'Maghanap ng achievement',
    sort_by_completed: 'Natapos',
    sort_by_name: 'Pangalan',
    sort_by_progress: 'Progreso',
    sort_by_xp: 'Gantimpalang XP',
    try_different_search: 'Subukan ang ibang salita o i-clear ang paghahanap.',
    all_players: 'Lahat ng manlalaro',
    champion: 'Kampeon',
    end_of_leaderboard: 'Narating mo na ang dulo ng leaderboard.',
    full_rankings: 'Buong ranggo',
    leaderboard_error: 'Hindi ma-load ang leaderboard ngayon.',
    leaderboard_error_desc: 'Pakisubukang muli sa ilang sandali.',
    loading_leaderboard: 'Nilo-load ang leaderboard',
    loading_leaderboard_desc: 'Kinukuha ang pinakabagong progreso ng mga manlalaro.',
    local: 'Malapit',
    needed: 'kailangan',
    next_level: 'Susunod na antas',
    no_rankings: 'Wala pang ranggo',
    no_rankings_description: 'Magpatuloy sa paglalaro at mapupuno ang leaderboard na ito.',
    pull_to_refresh: 'I-pull para mag-refresh',
    refreshing: 'Nire-refresh…',
    top_10: 'Top 10',
    top_performers: 'Mga nangungunang manlalaro',
    you: 'Ikaw',
    // Rewards and XP
    rewards_earned: 'Mga Gantimpalang Nakuha',
    to_next_level: 'sa Susunod na Level',
    day_streak: 'Sunod-sunod',
    view_progress: 'Tingnan ang Pag-unlad',
    experience_points: 'Mga Puntos ng Karanasan',
    xp_short: 'KP',
    progress_to_next_level: 'Pag-unlad sa Susunod na Level',
    achievement_unlocked: 'Tagumpay na Na-unlock!',
    
    // Leveling
    current_level: 'Kasalukuyang Level',
    total_xp: 'Kabuuang KP',
    level: 'Level',
    rank: 'Ranggo',
    
    // Achievements
    achievements: 'Mga Tagumpay',
    earned: 'Nakuha',
    total: 'Kabuuan',
    more_to_go: 'pa ang kailangan',
    completed_on: 'Natapos noong',
    ready_to_earn: 'Handa nang makuha',
    
    // Progress
    your_progress: 'Inyong Pag-unlad',
    calculating_rewards: 'Kinakalkula ang mga Gantimpala',
    gamification_error: 'Hindi Ma-load ang mga Gantimpala',
    
    // Streaks
    current_streak: 'Kasalukuyang Streak',
    longest_streak: 'Pinakamahabang Streak',
    daily_verse: 'Talata Ngayon',
    verse_prompt: 'Tuklasin natin ito nang magkasama',
    mark_as_read: 'Markahan bilang Nabasa',
    completed_today: 'Natapos Ngayon',
    daily_verse_completed_message: 'Natapos ang talata ngayon! Nakakuha ka ng 5 KP.',
    
    // Actions
    quick_actions: 'Mga Mabilis na Aksyon',
    best: 'Pinakamahusay',
    new_personal_best: 'Bagong Personal na Record',
    
    // Dashboard
    dashboard_subtitle: 'Subaybayan ang iyong paglago, ipagdiwang ang mga tagumpay, at lumago sa Kasulatan',
    achievements_hero_title: 'Mga milyahe sa Kasulatan',
    achievements_hero_subtitle: 'Ipagdiwang ang tapat na pag-unlad at tingnan ang susunod na mga milyahe.',
    streak_calendar: 'Sunod-sunod',
    day_singular: 'araw',
    days: 'mga araw',
    leaderboard: 'Leaderboard',
    quizzes_completed: 'quiz',
    leaderboard_hero_title: 'Sabay na lumago',
    leaderboard_hero_subtitle: 'Tingnan kung paano hinuhubog ng tuloy-tuloy na pag-aaral ang iyong paglalakbay.',
    global_rank: 'iyong paglalakbay',
    quiz_stats: 'Mga Stats ng Quiz',
    view_performance: 'Tingnan ang performance',
    
    // Status and Messages
    not_available: 'Hindi Available',
    unranked: 'Walang ranggo',
    congratulations: 'Pagbati!',
    loading_progress: 'Naglo-load ng progress',
    error_loading_progress: 'Error sa pag-load ng progress',
    try_again: 'Subukan ulit',
    refresh_cta: 'I-refresh ang ranggo',
    completed: 'Tapos na',
    activity_types: 'Mga uri ng aktibidad',
    unlocked: 'na-unlock',
    recent_activity: 'Kamakailang Aktibidad',
    recent_xp_earned: 'Kamakailang KP na Nakuha',
    recent_achievements_earned: 'Kamakailang Mga Tagumpay na Nakuha',
    
    // Ranks
    beginner: 'Nagsisimula',
    scholar: 'Iskolar',
    teacher: 'Guro',
    sage: 'Pantas',
    intermediate: 'Intermediate',
    advanced: 'Advanced',
    expert: 'Eksperto',
    master: 'Master',
    
    // Quiz completion messages
    quiz_completed_with_score: 'Quiz natapos na may {score}% na score',
    quiz_completed: 'Quiz natapos',
    daily_challenge_completed: 'Araw-araw na hamon natapos',
  },
  
  it: {
    category_completion: 'Completamento',
    category_accuracy: 'Precisione',
    category_speed: 'Velocità',
    category_competition: 'Competizione',
    category_exploration: 'Esplorazione',
    longest: 'Più lunga',
    last_activity: 'Ultima attività',
    streak_milestones: 'Traguardi della serie',
    milestone_week: 'Una settimana nella Parola',
    milestone_month: 'Un mese di fedeltà',
    milestone_quarter: 'Tre mesi di costanza',
    milestone_year: 'Un anno intero nelle Scritture',
    streak_tips: 'Mantieni viva la tua serie',
    tip_start_streak: 'Inizia oggi con un piccolo passo fedele.',
    tip_daily_consistency: 'Pochi minuti con le Scritture ogni giorno creano slancio.',
    tip_grace_period: 'Se la vita si fa frenetica, torna con calma domani e prosegui.',
    tip_multiple_activities: 'Quiz, versetti e gioco condiviso rafforzano il tuo ritmo.',
    tip_set_reminders: 'Imposta un promemoria quotidiano perché le Scritture restino parte della tua giornata.',
    tip_keep_going: 'Stai costruendo una bella abitudine. Continua a esserci.',
    start_your_streak: 'Inizia la tua serie',
    streak_calendar_error: 'Al momento non è stato possibile caricare la tua serie.',
    streak_connection_error: 'Gli aggiornamenti della serie sono temporaneamente non disponibili.',
    category_all: 'Tutti',
    category_knowledge: 'Conoscenza',
    category_consistency: 'Costanza',
    category_community: 'Comunità',
    category_mastery: 'Padronanza',
    category_special: 'Speciali',
    category_quiz: 'Quiz',
    category_streak: 'Serie',
    category_challenge: 'Sfida',
    category_social: 'Sociale',
    category_milestone: 'Traguardo',
    category_daily: 'Giornaliero',
    category_weekly: 'Settimanale',
    category_monthly: 'Mensile',
    achievements_connection_error: 'Gli aggiornamenti degli obiettivi sono temporaneamente non disponibili.',
    achievements_error: 'Al momento non è stato possibile caricare i tuoi obiettivi.',
    no_achievements: 'Ancora nessun obiettivo',
    no_achievements_description: 'Continua a rispondere con fedeltà e i tuoi traguardi appariranno qui.',
    no_search_results: 'Nessun obiettivo corrispondente',
    search_achievements: 'Cerca obiettivi',
    sort_by_completed: 'Completati',
    sort_by_name: 'Nome',
    sort_by_progress: 'Progresso',
    sort_by_xp: 'Ricompensa XP',
    try_different_search: 'Prova un\'altra parola o cancella la ricerca.',
    all_players: 'Tutti i giocatori',
    champion: 'Campione',
    end_of_leaderboard: 'Hai raggiunto la fine della classifica.',
    full_rankings: 'Classifica completa',
    leaderboard_error: 'Al momento non è stato possibile caricare la classifica.',
    leaderboard_error_desc: 'Riprova tra un momento.',
    loading_leaderboard: 'Caricamento della classifica',
    loading_leaderboard_desc: 'Raccolta degli ultimi progressi dei giocatori.',
    local: 'Vicino',
    needed: 'necessari',
    next_level: 'Livello successivo',
    no_rankings: 'Ancora nessuna classifica',
    no_rankings_description: 'Continua a giocare e questa classifica inizierà a riempirsi.',
    pull_to_refresh: 'Trascina per aggiornare',
    refreshing: 'Aggiornamento…',
    top_10: 'Top 10',
    top_performers: 'Migliori giocatori',
    you: 'Tu',
    // Rewards and XP
    rewards_earned: 'Ricompense Guadagnate',
    to_next_level: 'al Prossimo Livello',
    day_streak: 'Serie',
    view_progress: 'Vedi Progressi',
    experience_points: 'Punti Esperienza',
    xp_short: 'ESP',
    progress_to_next_level: 'Progresso al Prossimo Livello',
    achievement_unlocked: 'Traguardo Sbloccato!',
    
    // Leveling
    current_level: 'Livello Attuale',
    total_xp: 'ESP Totali',
    level: 'Livello',
    rank: 'Grado',
    
    // Achievements
    achievements: 'Traguardi',
    earned: 'Guadagnato',
    total: 'Totale',
    more_to_go: 'ancora da fare',
    completed_on: 'Completato il',
    ready_to_earn: 'Pronto da ottenere',
    
    // Progress
    your_progress: 'I Tuoi Progressi',
    calculating_rewards: 'Calcolo Ricompense',
    gamification_error: 'Impossibile Caricare le Ricompense',
    
    // Streaks
    current_streak: 'Serie Attuale',
    longest_streak: 'Serie Più Lunga',
    daily_verse: 'Versetto di Oggi',
    verse_prompt: 'Esploriamo questo insieme',
    mark_as_read: 'Segna come Letto',
    completed_today: 'Completato Oggi',
    daily_verse_completed_message: 'Versetto del giorno completato! Hai guadagnato 5 ESP.',
    
    // Actions
    quick_actions: 'Azioni Rapide',
    best: 'Migliore',
    new_personal_best: 'Nuovo Record Personale',
    
    // Dashboard
    dashboard_subtitle: 'Segui la tua crescita, celebra i traguardi e cresci nelle Scritture',
    achievements_hero_title: 'Traguardi nelle Scritture',
    achievements_hero_subtitle: 'Celebra il tuo progresso fedele e scopri i prossimi traguardi.',
    streak_calendar: 'Serie',
    day_singular: 'giorno',
    days: 'giorni',
    leaderboard: 'Classifica',
    quizzes_completed: 'quiz',
    leaderboard_hero_title: 'Crescere insieme',
    leaderboard_hero_subtitle: 'Guarda come uno studio costante sta plasmando il tuo percorso.',
    global_rank: 'il tuo percorso',
    quiz_stats: 'Statistiche Quiz',
    view_performance: 'Visualizza prestazioni',
    
    // Status and Messages
    not_available: 'N/D',
    unranked: 'Non classificato',
    congratulations: 'Congratulazioni!',
    loading_progress: 'Caricamento progresso',
    error_loading_progress: 'Errore nel caricamento del progresso',
    try_again: 'Riprova',
    refresh_cta: 'Aggiorna classifica',
    completed: 'Completato',
    activity_types: 'Tipi di attività',
    unlocked: 'sbloccati',
    recent_activity: 'Attività Recente',
    recent_xp_earned: 'ESP Recenti Guadagnati',
    recent_achievements_earned: 'Traguardi Recenti Ottenuti',
    
    // Ranks
    beginner: 'Principiante',
    scholar: 'Studioso',
    teacher: 'Insegnante',
    sage: 'Saggio',
    intermediate: 'Intermedio',
    advanced: 'Avanzato',
    expert: 'Esperto',
    master: 'Maestro',
    
    // Quiz completion messages
    quiz_completed_with_score: 'Quiz completato con {score}% di punteggio',
    quiz_completed: 'Quiz completato',
    daily_challenge_completed: 'Sfida giornaliera completata',
  },
  
  am: {
    category_completion: 'ማጠናቀቅ',
    category_accuracy: 'ትክክለኛነት',
    category_speed: 'ፍጥነት',
    category_competition: 'ውድድር',
    category_exploration: 'ምርምር',
    longest: 'ረጅሙ',
    last_activity: 'የመጨረሻ እንቅስቃሴ',
    streak_milestones: 'የተከታታይ ወሳኝ ምዕራፎች',
    milestone_week: 'በቃሉ ውስጥ አንድ ሳምንት',
    milestone_month: 'የአንድ ወር ታማኝነት',
    milestone_quarter: 'የሦስት ወር ወጥነት',
    milestone_year: 'በቅዱስ መጽሐፍ ውስጥ አንድ ሙሉ ዓመት',
    streak_tips: 'ተከታታይዎን ያቆዩ',
    tip_start_streak: 'ዛሬ በአንድ ትንሽ ታማኝ እርምጃ ይጀምሩ።',
    tip_daily_consistency: 'በየቀኑ ጥቂት ደቂቃዎች ከቅዱስ መጽሐፍ ጋር መሆን ግስጋሴ ይገነባል።',
    tip_grace_period: 'ሕይወት ከተጨናነቀ ነገ በእርጋታ ተመልሰው ይቀጥሉ።',
    tip_multiple_activities: 'ጥያቄዎች፣ ጥቅሶችና የጋራ ጨዋታ ሁሉም ዜማዎን ያጠናክራሉ።',
    tip_set_reminders: 'ቅዱስ መጽሐፍ የቀንዎ አካል እንዲሆን ዕለታዊ ማስታወሻ ያዘጋጁ።',
    tip_keep_going: 'ውብ ልማድ እየገነቡ ነው። መገኘትዎን ይቀጥሉ።',
    start_your_streak: 'ተከታታይዎን ይጀምሩ',
    streak_calendar_error: 'አሁን ተከታታይዎን መጫን አልተቻለም።',
    streak_connection_error: 'የተከታታይ ዝማኔዎች ለጊዜው አይገኙም።',
    category_all: 'ሁሉም',
    category_knowledge: 'እውቀት',
    category_consistency: 'ወጥነት',
    category_community: 'ማህበረሰብ',
    category_mastery: 'ብቃት',
    category_special: 'ልዩ',
    category_quiz: 'ጥያቄ',
    category_streak: 'ተከታታይ',
    category_challenge: 'ፈተና',
    category_social: 'ማህበራዊ',
    category_milestone: 'ወሳኝ ምዕራፍ',
    category_daily: 'ዕለታዊ',
    category_weekly: 'ሳምንታዊ',
    category_monthly: 'ወርሃዊ',
    achievements_connection_error: 'የስኬት ዝማኔዎች ለጊዜው አይገኙም።',
    achievements_error: 'አሁን ስኬቶችዎን መጫን አልተቻለም።',
    no_achievements: 'እስካሁን ስኬት የለም',
    no_achievements_description: 'በታማኝነት መመለስዎን ይቀጥሉ፣ ወሳኝ ምዕራፎችዎ እዚህ ይታያሉ።',
    no_search_results: 'ተዛማጅ ስኬት የለም',
    search_achievements: 'ስኬቶችን ፈልግ',
    sort_by_completed: 'የተጠናቀቁ',
    sort_by_name: 'ስም',
    sort_by_progress: 'እድገት',
    sort_by_xp: 'የXP ሽልማት',
    try_different_search: 'ሌላ ቃል ይሞክሩ ወይም ፍለጋውን ያጽዱ።',
    all_players: 'ሁሉም ተጫዋቾች',
    champion: 'ሻምፒዮን',
    end_of_leaderboard: 'የደረጃ ሰንጠረዡ መጨረሻ ላይ ደርሰዋል።',
    full_rankings: 'ሙሉ ደረጃዎች',
    leaderboard_error: 'አሁን የደረጃ ሰንጠረዡን መጫን አልተቻለም።',
    leaderboard_error_desc: 'እባክዎ ከትንሽ ቆይታ በኋላ እንደገና ይሞክሩ።',
    loading_leaderboard: 'የደረጃ ሰንጠረዥ በመጫን ላይ',
    loading_leaderboard_desc: 'የተጫዋቾችን አዲስ እድገት በማሰባሰብ ላይ።',
    local: 'በአቅራቢያ',
    needed: 'ያስፈልጋል',
    next_level: 'ቀጣይ ደረጃ',
    no_rankings: 'እስካሁን ደረጃ የለም',
    no_rankings_description: 'መጫወትዎን ይቀጥሉ፣ ይህ የደረጃ ሰንጠረዥ መሙላት ይጀምራል።',
    pull_to_refresh: 'ለማደስ ይጎትቱ',
    refreshing: 'በማደስ ላይ…',
    top_10: 'ምርጥ 10',
    top_performers: 'ከፍተኛ ተጫዋቾች',
    you: 'እርስዎ',
    // Rewards and XP
    rewards_earned: 'የተገኙ ሽልማቶች',
    to_next_level: 'ወደ ቀጣዩ ደረጃ',
    day_streak: 'ተከታታይ',
    view_progress: 'እድገትን ይመልከቱ',
    experience_points: 'የልምድ ነጥቦች',
    xp_short: 'ልነ',
    progress_to_next_level: 'ወደ ቀጣዩ ደረጃ እድገት',
    achievement_unlocked: 'ስኬት ተከፍቷል!',
    
    // Leveling
    current_level: 'አሁን ያለው ደረጃ',
    total_xp: 'ጠቅላላ ልነ',
    level: 'ደረጃ',
    rank: 'ደረጃ',
    
    // Achievements
    achievements: 'ስኬቶች',
    earned: 'ተገኝቷል',
    total: 'ጠቅላላ',
    more_to_go: 'የቀሩ',
    completed_on: 'የተጠናቀቀበት',
    ready_to_earn: 'ለማግኘት ዝግጁ',
    
    // Progress
    your_progress: 'የእርስዎ እድገት',
    calculating_rewards: 'ሽልማቶችን በማስላት ላይ',
    gamification_error: 'ሽልማቶችን መጫን አይቻልም',
    
    // Streaks
    current_streak: 'አሁን ያለው ተከታታይ',
    longest_streak: 'ረጅሙ ተከታታይ',
    daily_verse: 'የዛሬ ጥቅስ',
    verse_prompt: 'ይህንን አብረን እንመርምር',
    mark_as_read: 'እንደተነበበ ምልክት አድርግ',
    completed_today: 'ዛሬ ተጠናቋል',
    daily_verse_completed_message: 'የዛሬ ጥቅስ ተጠናቋል! 5 ልነ አግኝተዋል።',
    
    // Actions
    quick_actions: 'ፈጣን ተግባራት',
    best: 'ምርጥ',
    new_personal_best: 'አዲስ የግል ምርጥ ውጤት',
    
    // Dashboard
    dashboard_subtitle: 'እድገትዎን ይከታተሉ፣ ስኬቶችን ያክብሩ እና በቅዱስ ጽሑፍ ያድጉ',
    achievements_hero_title: 'በቅዱስ ጽሑፍ ውስጥ ያሉ ደረጃዎች',
    achievements_hero_subtitle: 'ታማኝ እድገትዎን ያክብሩ እና ቀጣዩን ደረጃ ይመልከቱ።',
    streak_calendar: 'ተከታታይ',
    day_singular: 'ቀን',
    days: 'ቀናት',
    leaderboard: 'የመሪዎች ሰሌዳ',
    quizzes_completed: 'ፈተናዎች',
    leaderboard_hero_title: 'አብረን እንድግ',
    leaderboard_hero_subtitle: 'ቀጣይ ጥናት ጉዞዎን እንዴት እየቀየረ እንደሆነ ይመልከቱ።',
    global_rank: 'ጉዞዎ',
    quiz_stats: 'የፈተና ስታቲስቲክስ',
    view_performance: 'አፈጻጸም ይመልከቱ',
    
    // Status and Messages
    not_available: 'የለም',
    unranked: 'ያልተደረገ',
    congratulations: 'እንኳን ደስ አላችሁ!',
    loading_progress: 'እድገት በመጫን ላይ',
    error_loading_progress: 'እድገት በመጫን ላይ ስህተት',
    try_again: 'እንደገና ይሞክሩ',
    refresh_cta: 'ደረጃውን አድስ',
    completed: 'ተጠናቋል',
    activity_types: 'የእንቅስቃሴ አይነቶች',
    unlocked: 'ተከፍቷል',
    recent_activity: 'የቅርብ ጊዜ እንቅስቃሴ',
    recent_xp_earned: 'የቅርብ ጊዜ ልነ የተገኘ',
    recent_achievements_earned: 'የቅርብ ጊዜ ስኬቶች የተገኙ',
    
    // Ranks
    beginner: 'ጀማሪ',
    scholar: 'ምሁር',
    teacher: 'አስተማሪ',
    sage: 'ጠቢብ',
    intermediate: 'መካከለኛ',
    advanced: 'የላቀ',
    expert: 'ባለሙያ',
    master: 'ማስተር',
    
    // Quiz completion messages
    quiz_completed_with_score: 'ከ {score}% ውጤት ጋር ጥያቄ ተጠናቀኟ',
    quiz_completed: 'ጥያቄ ተጠናቀ',
    daily_challenge_completed: 'የቅኑ አጠጋጊ ተጠናቀ',
  },
  
  ko: {
    category_completion: '완료',
    category_accuracy: '정확도',
    category_speed: '속도',
    category_competition: '경쟁',
    category_exploration: '탐험',
    longest: '최장',
    last_activity: '마지막 활동',
    streak_milestones: '연속 기록 이정표',
    milestone_week: '말씀 안에서 일주일',
    milestone_month: '한 달간의 신실함',
    milestone_quarter: '석 달간의 꾸준함',
    milestone_year: '성경과 함께한 1년',
    streak_tips: '연속 기록을 이어 가세요',
    tip_start_streak: '오늘 작은 신실한 한 걸음으로 시작하세요.',
    tip_daily_consistency: '매일 몇 분의 말씀이 꾸준한 힘이 됩니다.',
    tip_grace_period: '바쁜 날이면 내일 편안히 돌아와 이어 가세요.',
    tip_multiple_activities: '퀴즈, 말씀 구절, 함께하는 플레이 모두 리듬을 단단하게 합니다.',
    tip_set_reminders: '매일 알림을 설정해 말씀이 하루의 일부가 되게 하세요.',
    tip_keep_going: '멋진 습관을 만들고 있어요. 계속 함께해요.',
    start_your_streak: '연속 기록 시작하기',
    streak_calendar_error: '지금은 연속 기록을 불러올 수 없습니다.',
    streak_connection_error: '연속 기록 업데이트를 일시적으로 사용할 수 없습니다.',
    category_all: '전체',
    category_knowledge: '지식',
    category_consistency: '꾸준함',
    category_community: '커뮤니티',
    category_mastery: '숙련',
    category_special: '특별',
    category_quiz: '퀴즈',
    category_streak: '연속',
    category_challenge: '도전',
    category_social: '소셜',
    category_milestone: '이정표',
    category_daily: '매일',
    category_weekly: '주간',
    category_monthly: '월간',
    achievements_connection_error: '업적 업데이트를 일시적으로 사용할 수 없습니다.',
    achievements_error: '지금은 업적을 불러올 수 없습니다.',
    no_achievements: '아직 업적이 없습니다',
    no_achievements_description: '꾸준히 답하면 이정표가 여기에 나타납니다.',
    no_search_results: '일치하는 업적이 없습니다',
    search_achievements: '업적 검색',
    sort_by_completed: '완료',
    sort_by_name: '이름',
    sort_by_progress: '진행도',
    sort_by_xp: 'XP 보상',
    try_different_search: '다른 단어를 입력하거나 검색을 지우세요.',
    all_players: '모든 플레이어',
    champion: '챔피언',
    end_of_leaderboard: '순위표의 끝에 도달했습니다.',
    full_rankings: '전체 순위',
    leaderboard_error: '지금은 순위표를 불러올 수 없습니다.',
    leaderboard_error_desc: '잠시 후 다시 시도해 주세요.',
    loading_leaderboard: '순위표 불러오는 중',
    loading_leaderboard_desc: '플레이어들의 최신 진행 상황을 모으는 중입니다.',
    local: '내 주변',
    needed: '필요',
    next_level: '다음 레벨',
    no_rankings: '아직 순위가 없습니다',
    no_rankings_description: '계속 플레이하면 이 순위표가 채워지기 시작합니다.',
    pull_to_refresh: '당겨서 새로고침',
    refreshing: '새로고침 중…',
    top_10: '상위 10명',
    top_performers: '상위 플레이어',
    you: '나',
    // Rewards and XP
    rewards_earned: '획득한 보상',
    to_next_level: '다음 레벨까지',
    day_streak: '연속',
    view_progress: '진행 상황 보기',
    experience_points: '경험치',
    xp_short: '경치',
    progress_to_next_level: '다음 레벨 진행도',
    achievement_unlocked: '업적 달성!',
    
    // Leveling
    current_level: '현재 레벨',
    total_xp: '총 경치',
    level: '레벨',
    rank: '랭크',
    
    // Achievements
    achievements: '업적',
    earned: '획득',
    total: '총합',
    more_to_go: '더 필요함',
    completed_on: '완료일',
    ready_to_earn: '획득 준비 완료',
    
    // Progress
    your_progress: '당신의 진행도',
    calculating_rewards: '보상 계산 중',
    gamification_error: '보상을 불러올 수 없음',
    
    // Streaks
    current_streak: '현재 연속',
    longest_streak: '최장 연속',
    daily_verse: '오늘의 구절',
    verse_prompt: '함께 알아봅시다',
    mark_as_read: '읽음으로 표시',
    completed_today: '오늘 완료',
    daily_verse_completed_message: '오늘의 구절을 완료했습니다! 경치 5점을 획득했습니다.',
    
    // Actions
    quick_actions: '빠른 작업',
    best: '최고',
    new_personal_best: '새로운 개인 기록',
    
    // Dashboard
    dashboard_subtitle: '성장을 추적하고, 이정표를 축하하며, 성경 안에서 자라세요',
    achievements_hero_title: '말씀 안의 이정표',
    achievements_hero_subtitle: '신실한 성장을 기념하고 다음 이정표를 확인하세요.',
    streak_calendar: '연속',
    day_singular: '일',
    days: '일',
    leaderboard: '리더보드',
    quizzes_completed: '퀴즈',
    leaderboard_hero_title: '함께 자라가기',
    leaderboard_hero_subtitle: '꾸준한 배움이 당신의 여정을 어떻게 빚어 가는지 확인하세요.',
    global_rank: '나의 여정',
    quiz_stats: '퀴즈 통계',
    view_performance: '성능 보기',
    
    // Status and Messages
    not_available: '없음',
    unranked: '순위 없음',
    congratulations: '축하합니다!',
    loading_progress: '진행 상황 로딩 중',
    error_loading_progress: '진행 상황 로딩 오류',
    try_again: '다시 시도',
    refresh_cta: '순위 새로고침',
    completed: '완료',
    activity_types: '활동 유형',
    unlocked: '해제됨',
    recent_activity: '최근 활동',
    recent_xp_earned: '최근 획득한 경치',
    recent_achievements_earned: '최근 획득한 업적',
    
    // Ranks
    beginner: '초보자',
    scholar: '학자',
    teacher: '교사',
    sage: '현자',
    intermediate: '중급자',
    advanced: '고급자',
    expert: '전문가',
    master: '마스터',
    
    // Quiz completion messages
    quiz_completed_with_score: '{score}% 점수로 퀴즈 완료',
    quiz_completed: '퀴즈 완료',
    daily_challenge_completed: '일일 챌린지 완료',
  },
};
